module.exports = __webpack_public_path__ + "img/1F6AC.bfd8c53c.svg";